module.exports = __webpack_public_path__ + "static/media/muskan_paryani.8da41c25.png";